import { FC } from 'react';
import classNames from 'classnames';

import styles from 'src/styles/common/templateGallery.module.scss';
import { TemplateGalleryTemplateIcon } from 'src/components/Modals/TemplateGallery/icons/TemplateIcon';
import { TemplateGalleryMostUsedListItemType } from 'src/models/Modals/templateGallery';

type Props = Omit<TemplateGalleryMostUsedListItemType, 'Url' | 'ID'> & {
  small?: boolean;
  onClick?: () => void;
};

export const TemplateGalleryTemplate: FC<Props> = ({ Name, small, CategoryNames, MediaUri, onClick }) => {
  const iconClassName = classNames(styles.icon, small && styles.small);

  const categories = CategoryNames?.join(', ');

  return (
    <div className={styles.template} role="presentation" onClick={onClick}>
      {MediaUri ? (
        <img className={iconClassName} src={MediaUri} alt={Name} />
      ) : (
        <TemplateGalleryTemplateIcon className={iconClassName} />
      )}
      <div>
        <div className={styles.name}>{Name}</div>
        {categories && <div className={styles.category}>{categories}</div>}
      </div>
    </div>
  );
};
